import { IconPad } from '../IconPad';
import React from 'react';
import PropTypes from 'prop-types';
import useTranslatedField from '../../hooks/useTranslatedField';


export const NamesFeature = ({ slug, trimLevel }) => {
  const t = useTranslatedField();
  const items = trimLevel[slug]?.edges ? trimLevel[slug].edges.map(({ node })=>node) :  trimLevel[slug];
  return (
    <IconPad>
      {items.map((x, k) => <span key={k}>{t(x, 'translatedName')||x.name}</span>)}
    </IconPad>
  );
};

NamesFeature.propTypes={
  slug: PropTypes.string.isRequired,
  trimLevel: PropTypes.object.isRequired
};
